import * as React from 'react';
import { Alert, Col, Row } from 'reactstrap';
import { AccentButton } from '../controls/AccentButton';
import { AccentUploadButton } from '../controls/AccentUpload';
import { updateAsFormData } from '../services/DataService';
import { accentUtils, t } from '../services/HelperService';
import { AccentDialog } from './AccentDialog';

export class ImportJobDlg extends React.Component {
    constructor(props) {
        super(props);

        this.uploadCtrl = React.createRef();
        this.onFilesChange = this.onFilesChange.bind(this);
        this.doUpload = this.doUpload.bind(this);
    }

    onFilesChange() {
        this.forceUpdate();
    }

    doUpload(e) {
        const me = this;
        this.uploadCtrl.current.getFilesForUpload().then(r => {
            updateAsFormData("Job_Import", { Files: r.files }).then(() => {
                if (e.promise) e.promise({ dropNotification: true });

                // give dropNotification thing time to animate before closing
                setTimeout(() => me.props.onClose({ canceled: false, successful: true }), 2000);
            });
        });
    }

    render() {
        const isValid =
            !accentUtils.isNull(this.uploadCtrl.current) &&
            this.uploadCtrl.current.fileCount() > 0 &&
            !this.uploadCtrl.current.hasInvalidFile();

        return (
            <AccentDialog
                className="importFilterDlg"
                maxWidth={650}
                onClose={this.props.onClose}
                headerContent={"Job Import"}
                actionsContent={[
                    <AccentButton key="2" tagName="jobImportBtn" onClick={this.doUpload} disabled={!isValid} requireNotificationDrop >
                        {t("application_strings.application.buttons.ok")}
                    </AccentButton>
                ]}
            >
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <Alert color="info">Upload a Job import workbook (.xls/.xlsx) or a zip containing one workbook.</Alert>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <AccentUploadButton
                                    ref={this.uploadCtrl}
                                    onChange={this.onFilesChange}
                                    allowedExtensions={['.xls', '.xlsx', '.zip']}
                                    multiple={false}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </AccentDialog>
        );
    }
}


